/**
 * Shared warn enrichment + rate-limit for [chat-dag.*] telemetry.
 *
 * Per plan-triad H8: every warn carries session_id + ISO timestamp +
 * correlation_id (uuid) so production debug can correlate across
 * frontend/backend logs.
 *
 * Per plan-triad H9: rate-limit by (warnKind + dedupeKey) per session
 * via module-level Set. Prevents console flood when a regression
 * fires the same drift across thousands of messages.
 */
const _emittedWarns = new Set<string>();

export type ChatDagWarnKind =
  | 'classify_drift'
  | 'cross_kind_parent'
  | 'cycle_bailout';

export function chatDagWarn(
  kind: ChatDagWarnKind,
  dedupeKey: string,
  payload: Record<string, unknown>,
): void {
  const sessionId =
    (typeof window !== 'undefined' && (window as any).__chatdagSessionId) ?? 'unknown';
  const key = `${sessionId}:${kind}:${dedupeKey}`;
  if (_emittedWarns.has(key)) return;
  _emittedWarns.add(key);

  console.warn(`[chat-dag.${kind}]`, {
    ...payload,
    session_id: sessionId,
    timestamp: new Date().toISOString(),
    correlation_id:
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? (crypto as any).randomUUID()
        : Math.random().toString(36).slice(2),
  });
}

// Test escape hatch — clears the dedupe set between tests.
export function _resetChatDagWarnsForTest(): void {
  _emittedWarns.clear();
}
